const ACCENTED_CHARACTERS = /[\u0300-\u036f]/g;
const SPECIAL_CHARACTERS = /[^a-zA-Z0-9]+/g;
function clearString(string) {
  return string.normalize("NFD").trim().replace(ACCENTED_CHARACTERS, "").replace(SPECIAL_CHARACTERS, " ");
}
const camelize = (string) => {
  if (!string) return string;
  const cleanedString = clearString(string);
  const stringArray = cleanedString.split(" ");
  return stringArray.reduce((result, word, index) => {
    const lowerLastLetter = word.slice(0, -1) + word.slice(-1).toLowerCase();
    const lowerFirstLetter = lowerLastLetter.toLowerCase()[0] + lowerLastLetter.slice(1);
    const upperFirstLetter = lowerLastLetter.toUpperCase()[0] + lowerLastLetter.slice(1);
    return result + (index ? upperFirstLetter : lowerFirstLetter);
  }, "");
};
function useDataTestIdProp() {
  function createTestIdProp() {
    return {
      dataTestid: {
        type: String,
        default: ""
      }
    };
  }
  function setupTestId(props) {
    function formatTestId(suffix = "") {
      if (!(props == null ? void 0 : props.dataTestid)) return "";
      return camelize(`${props.dataTestid} ${suffix}`).trim();
    }
    return {
      formatTestId
    };
  }
  return {
    createTestIdProp,
    setupTestId
  };
}
export {
  camelize as c,
  useDataTestIdProp as u
};
